import React from 'react';
import './CTA.css';

const CTA = () => {
  return (
    <section className="cta-section-new">
      <div className="container">
        <div className="cta-content-new">
          <div className="cta-text-new">
            <h2>Ready to Transform Your Business?</h2>
            <p>Join forward-thinking businesses that are already saving time and money with AI Voice Agents and Chatbots</p>
            <div className="cta-buttons-new">
              <a href="#contact" className="btn-primary-new">
                <i className="fas fa-paper-plane"></i>
                Get Free Consultation
              </a>
            </div>
          </div>
          <div className="cta-visual-new">
            <div className="success-metrics">
              <div className="metric-item">
                <div className="metric-number">24/7</div>
                <div className="metric-label">Customer Support</div>
              </div>
              <div className="metric-item">
                <div className="metric-number">&gt;50%</div>
                <div className="metric-label">Cost Reduction</div>
              </div>
              <div className="metric-item">
                <div className="metric-number">Quick</div>
                <div className="metric-label">Setup Time</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
